import React from 'react'
import { useContext, useEffect, useState } from 'react'
import { useActions } from '../../Action'
import { store } from '../../Store'
import ReportSummary from './reportsummary'
import ReportingCareCreditReport from './carecreditreports'
import ReportDetails from './reportdetails'
import { MemoryRouter as Router, Switch, Route, Link } from 'react-router-dom'
import PricingReport from './pricingreports'
const INVOKE_ONCE = true

const Reporting = () => {
  const { state, dispatch } = useContext(store)
  const actions = useActions(state, dispatch)
  const { Login, roles, ReportingDetailsInputFields } = state
  const { StoreAgentRole } = Login
  const ReportingRoles = roles && roles.filter((r) => r.menu === 'Reporting' && r.section === 'Tabs') && roles && roles.filter((r) => r.menu === 'Reporting' && r.section === 'Tabs')[0]
  const agentRole = StoreAgentRole && StoreAgentRole.toUpperCase()

  const pricingReportTab = () => {
    actions.setReportDetailsTab(false)
    actions.setReportCareCreditTab(false)
    actions.setReportSummaryTab(false)
    actions.setReportPricingTab(true)
  }

  const careCreditReportTab = () => {
    actions.setReportDetailsTab(false)
    actions.setReportCareCreditTab(true)
    actions.setReportSummaryTab(false)
    actions.setReportPricingTab(false)
  }

  const reportSummaryTab = () => {
    actions.setReportDetailsTab(false)
    actions.setReportCareCreditTab(false)
    actions.setReportSummaryTab(true)
    actions.setReportPricingTab(false)
  }

  const reportDetailsTab = () => {
    actions.setReportDetailsTab(true)
    actions.setReportCareCreditTab(false)
    actions.setReportSummaryTab(false)
    actions.setReportPricingTab(false)

    let GetReportSummaryRequest = {
      PartnerStoreId: (state && state.Login && state.Login.StoreAgentRole && state.Login.StoreAgentRole.toUpperCase() === 'STORE') ? Login.PartnerStoreId : "",
      TradeQuoteNbr: ReportingDetailsInputFields.Tradeid,
      StartDate: ReportingDetailsInputFields.StartDate,
      EndDate: ReportingDetailsInputFields.EndDate,
      State: ReportingDetailsInputFields.State,
      Status: ReportingDetailsInputFields.Status,
      StoreName: ReportingDetailsInputFields.StoreName,
      PageSize: 10,
      PageNumber: 1,
    }
    actions.setReportSelectedPage(0)
    actions.getReportingDetails({ GetReportSummaryRequest })
  }

  const {
    reportingDetailsTab,
    reportingCareCreditTab,
    reportingSummaryTab,
    reportingPricingTab
  } = state

  return (
    <Router>
      <div className="ml-50 mr-50 min-h-718 mb-100 font-VodafoneRg">
        <div className="flex items-center pt-30">
          <h2 className="text-32 leading-37 p-1 font-VodafoneRgBd">Reporting</h2>
          {ReportingRoles['ReportSummary'][agentRole] === 'SHOW' && (
            <div className={`${reportingSummaryTab ? 'text-red-1' : 'text-grey-3'} text-17 text-center ml-8 py-2 m-2 font-VodafoneRgBd`}>
              <Link
                to="/reportsummary"
                onClick={() => {
                  reportSummaryTab()
                }}
                className="cursor-pointer"
              >
                Summary
              </Link>
            </div>
          )}
          {ReportingRoles['ReportDetails'][agentRole] === 'SHOW' && (
            <div className={`${reportingDetailsTab ? 'text-red-1' : 'text-grey-3'} text-17 text-center ml-m5 py-2 m-2 font-VodafoneRgBd`}>
              <Link
                to="/reportdetails"
                onClick={() => {
                  reportDetailsTab()
                }}
                className="cursor-pointer"
              >
                Details
              </Link>
            </div>
          )}
          {ReportingRoles['CareCreditReport'][agentRole] === 'SHOW' && (
            <div className={`${reportingCareCreditTab ? 'text-red-1' : 'text-grey-3'} text-17 leading-22 text-center ml-m5 py-2 m-2 font-VodafoneRgBd`}>
              <Link
                to="/carecreditreport"
                onClick={() => {
                  careCreditReportTab()
                }}
                className="cursor-pointer"
              >
                Credit Report
              </Link>
            </div>
          )}
          {ReportingRoles['PricingReport'][agentRole] === 'SHOW' && (
            <div className={`${reportingPricingTab ? 'text-red-1' : 'text-grey-3'} text-17 leading-22 text-center ml-m5 py-2 m-2 font-VodafoneRgBd`}>
              <Link
                to="/pricingreport"
                onClick={() => {
                  pricingReportTab()
                }}
                className="cursor-pointer"
              >
                Pricing Report
              </Link>
            </div>
          )}
        </div>
        <Switch>
          <Route path="/reportdetails">
            <ReportDetails />
          </Route>
          <Route path="/reportsummary">
            <ReportSummary />
          </Route>
          <Route path="/carecreditreport">
            <ReportingCareCreditReport />
          </Route>
          <Route path="/pricingreport">
            <PricingReport />
          </Route>
          <Route exact path="/">
            <ReportSummary />
          </Route>
        </Switch>
      </div>
    </Router>
  )
}

export default Reporting
